module.exports = __webpack_public_path__ + "fonts/GT-America-Standard-Bold.eaf6ea6b.ttf";